import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CurrentUser } from '../models/current-user';
import { Constants } from '../utilities/constants';
import { Organization, UserOrganization } from '../models/organization';
import { Team, UserTeam } from '../models/team';
import { User } from '../models/user';
import { Session, SessionDetail, SessionProgress } from '../models/session';
import { SessionComponent } from '../pages/session/session.component';
import { Trip } from '../models/trip';
import { GlobalItem, GraphItem } from '../models/graphItem';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient
    //, private authService: AuthService
  ) { }

  private get<T>(uri: string): Observable<T> {
    return this.http.get<T>(Constants.apiRoot + '/' + uri);
  }

  private post<T>(uri: string, data: any): Observable<T> {
    return this.http.post<T>(Constants.apiRoot + '/' + uri, data);
  }

  // Configurazioni
  public getEnums(): Observable<any[]> {
    return this.get<any[]>('configuration/enums')
  }

  // Percorsi
  public getGlobalMeasures(ids: number[]): Observable<GlobalItem[]> {
    return this.post<GlobalItem[]>('trip/read/global', ids);
  }

  public getGraphMeasures(ids: number[]): Observable<GraphItem[]> {
    return this.post<GraphItem[]>('trip/read/graph', ids);
  }

  public getImuMeasures(ids: number[]): Observable<GraphItem[]> {
    return this.post<GraphItem[]>('trip/read/imu', ids);
  }

  public getTrip(ids: number[]): Observable<Trip> {
    return this.post<Trip>('trip/read', ids);
  }

  // Organizzazioni
  public getOrganizations(): Observable<Organization[]> {
    return this.get<Organization[]>('organization/list');
  }

  public getOrganizationsSelectable(): Observable<UserOrganization[]> {
    return this.get<UserOrganization[]>('organization/selection');
  }

  public getOrganizationTeams(id: number): Observable<UserTeam[]> {
    return this.get<UserTeam[]>('organization/teams/' + id)
  }

  public addOrganization(organization: Organization): Observable<boolean> {
    return this.post<boolean>('organization/add', organization);
  }

  public updateOrganization(organization: Organization): Observable<boolean> {
    return this.post<boolean>('organization/update', organization);
  }

  // Sessioni
  public getSessions(): Observable<Session[]> {
    return this.get<Session[]>('session/list');
  }

  public addSession(session: Session): Observable<boolean> {
    return this.post<boolean>('session/add', session);
  }

  public deleteSessionFiles(session: SessionDetail, userId: number): Observable<boolean> {
    const payload: number[] = [ session.organizationId, session.teamId, session.sessionId, userId ];

    return this.post<boolean>('session/delete/files', payload);
  }

  public getSession(ids: number[]): Observable<SessionDetail> {
    return this.post<SessionDetail>('session/read', ids);
  }

  public getProgressExecution(uuid: string): Observable<SessionProgress[]> {
    let payload: string[] = [uuid];
    return this.post<SessionProgress[]>('session/progress', payload);
  }

  public startElaboration(uuid: string): Observable<string[]> {
    let payload: string[] = [uuid];
    return this.post<string[]>('session/elaborate', payload);
  }

  public updateSession(session: Session): Observable<boolean> {
    return this.post<boolean>('session/update', session);
  }

  public uploadData(ids: number[]): Observable<string[]> {
    return this.post<string[]>('session/upload/data', ids);
  }

  public uploadFile(data: FormData): Observable<any> {
    return this.http.post(Constants.apiRoot + '/session/upload/file', data, { reportProgress: true, observe: 'events', responseType: 'text' });
  }

  // Squadre
  public getTeams(): Observable<Team[]> {
    return this.get<Team[]>('team/list');
  }

  public addTeam(team: Team): Observable<boolean> {
    return this.post<boolean>('team/add', team);
  }

  public getTeamUsers(ids: number[]): Observable<User[]> {
    return this.post<User[]>('team/users', ids);
  }

  public updateTeam(team: Team): Observable<boolean> {
    return this.post<boolean>('team/update', team);
  }

  // Utente Corrente
  public getCurrentUser(): Observable<CurrentUser> {
    return this.get<CurrentUser>('user/current');
  }

  public changePassword(oldValue: string, newValue: string): Observable<boolean> {
    let payload = [{
      old: oldValue,
      new: newValue
    }];

    return this.post<boolean>('user/current/change', payload);
  }

  public updateCurrentUser(user: CurrentUser): Observable<any> {
    return this.post<any>('user/current/update', user);
  }

  // Utenti
  public getUsers(): Observable<User[]> {
    return this.get<User[]>('user/list')
  }

  public addUser(user: User): Observable<number> {
    return this.post<number>('user/add', user);
  }

  public deleteUser(user: User): Observable<any> {
    return this.post<any>('user/delete', user);
  }

  public linkUser(user: User): Observable<any> {
    return this.post<any>('user/link', user);
  }

  public resetPassword(user: User): Observable<any> {
    let data = [{
      id: user.userId
    }];
    return this.post<any>('user/reset', data);
  }

  public updateUser(user: User): Observable<boolean> {
    return this.post<boolean>('user/update', user);
  }

  public getUserRelations(userId: number): Observable<UserOrganization[]> {
    let data = [{
      id: userId
    }];
    return this.post<UserOrganization[]>('user/relations', data)
  }
}



